module.exports = __webpack_public_path__ + "media/cb.fc36ab6c.mp3";